import { type UseFormReturn } from 'react-hook-form';

import {
  AuditLightingCountFormEntrySchema,
  type AuditLightingCountFormEntry,
} from '#packages/data-collection/models/audit-lighting-count-form';

export const EditAuditFormLightingCountEntryDataSchema =
  AuditLightingCountFormEntrySchema;

export type EditAuditFormLightingCountEntryData = AuditLightingCountFormEntry;

export type EditAuditFormLightingCountEntry =
  UseFormReturn<EditAuditFormLightingCountEntryData>;
